module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-items-bg-e87f43938cb92ab77c4f18e94b8414f8.png";